var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.popped)?_c('Tweet',{attrs:{"id":_vm.tweetId}},[_c('div',{staticClass:"load"},[_c('div',{staticClass:"spinner-border",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"})])])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }